import { Divider, Grid2 as Grid, Typography } from "@mui/material";
import { useTranslate } from "@refinedev/core";

import { Form } from "@shared/components";
import {
  CompaniesAutocomplete,
  VouchersAutocomplete,
  StoresAutocomplete,
} from "@shared/components/AutocompleteFields";
import {
  useDiscountTypeOptions,
  useModeOptions,
} from "@shared/options";
import { useFormContext } from "react-hook-form";

export function DiscountForm() {
  const translate = useTranslate();

  const { getModeOptions } = useModeOptions();
  const { getDiscountTypeOptions } = useDiscountTypeOptions();

  const { watch } = useFormContext();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 6 }}>
        <CompaniesAutocomplete
          name="company"
          label={translate("v1/discount_admin.fields.company")}
          required
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <VouchersAutocomplete
          name="voucher_batch"
          label={translate("v1/discount_admin.fields.voucher_batch")}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="name"
          label={translate("v1/discount_admin.fields.name")}
          required
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="vindi_product_id"
          label={translate("v1/discount_admin.fields.vindi_product_id")}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="description"
          label={translate("v1/discount_admin.fields.description")}
          multiline
          minRows={4}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Divider />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Typography style={{ fontSize: 18, color: "primary.main" }}>
          Campanha
        </Typography>
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.DatePicker
          name="start_date"
          label={translate("v1/discount_admin.fields.start_date")}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.DatePicker
          name="end_date"
          label={translate("v1/discount_admin.fields.end_date")}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Select
          name="mode"
          label={translate("v1/discount_admin.fields.mode")}
          options={getModeOptions()}
          required
        />
      </Grid>

      <Grid
        size={{ xs: 6 }}
        display={{
          xs: watch("mode") === "online" ? "block" : "none",
        }}
      >
        <Form.Input name="link" label={"Link do Site"} />
      </Grid>

      <Grid
        size={{ xs: 6 }}
        display={{
          xs: watch("mode") === "online" ? "block" : "none",
        }}
      >
        <Form.Input name="coupon" label={"Cupom"} />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Select
          name="type"
          label={translate("v1/discount_admin.fields.type")}
          options={getDiscountTypeOptions()}
          required
        />
      </Grid>

      <Grid
        size={{ xs: 6 }}
        display={{
          xs: watch("type") === "discount" ? "block" : "none",
        }}
      >
        <Form.Input
          name="discount"
          label={translate("v1/discount_admin.fields.discount")}
          type="number"
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Switch
          name="active"
          label={translate("v1/discount_admin.fields.active")}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Switch
          name="in_all_stores"
          label={translate("v1/discount_admin.fields.in_all_stores")}
        />
      </Grid>

      <Grid
        size={{ xs: 12 }}
        display={{
          xs:
            watch("mode") === "local" && !watch("in_all_stores")
              ? "block"
              : "none",
        }}
      >
        <StoresAutocomplete
          name="stores"
          label={"Lojas"}
          multiple
        />
      </Grid>

      <Grid
        size={{ xs: 12 }}
        display={{
          xs: watch("mode") === "local" ? "block" : "none",
        }}
      >
        <Form.Switch name="limited_codes" label={"Códigos Limitados"} />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Divider />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Typography style={{ fontSize: 18, color: "primary.main" }}>
          {translate("v1/discount_admin.titles.details")}
        </Typography>
      </Grid>

      <Grid size={{ xs: 4 }}>
        <Form.Input
          name="original_price"
          label={translate("v1/discount_admin.fields.original_price")}
        />
      </Grid>

      <Grid size={{ xs: 4 }}>
        <Form.Input
          name="buy_price"
          label={translate("v1/discount_admin.fields.buy_price")}
        />
      </Grid>

      <Grid size={{ xs: 4 }}>
        <Form.Input
          name="sale_price"
          label={translate("v1/discount_admin.fields.sale_price")}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Switch
          name="pop_up"
          label={translate("v1/discount_admin.fields.pop_up")}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Switch
          name="featured"
          label={translate("v1/discount_admin.fields.featured")}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="rules"
          label={translate("v1/discount_admin.fields.rules")}
          multiline
          minRows={4}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="how_to_use"
          label={translate("v1/discount_admin.fields.how_to_use")}
          multiline
          minRows={4}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.SinglePhotoPicker
          name="image"
          label={translate("v1/discount_admin.fields.image")}
          shape="square"
          size={150}
        />
      </Grid>
    </Grid>
  );
}
